import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost, corporateHost } from "~/Utils";

interface DocumentDetailsResponse {
  id: number;
  title_en: string;
  title_malay: string;
  title_mandarin: string;
  answer_en: string;
  answer_malay: string;
  answer_mandarian: string;
  published: boolean;
  created_at: string;
  updated_at: string;
  eraman_sync: boolean;
  corporate_sync: boolean;
  myairport_sync: boolean;
  magp_sync: boolean;
  order_sequence: number;
  field_project_airport: any;
  module_name: any;
  key_info_type: any;
}

const fetchCentralisedFAQsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/get-faq-data/all-fields/${id}`);
  return response.data[0];
};

const useCentralisedFAQsDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["centralisedFAQs", id],
      enabled: false,
      queryFn: () => {
        return fetchCentralisedFAQsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCentralisedFAQsDetails };
